import { Button, DownSmallLineIcon, Dropdown, Flex, Text } from 'ui';
import variables from 'common/styles/variables.json';

interface FilterItem {
  key: string;
  name: string;
}

interface FilterProperties {
  filter: string;
  items: FilterItem[];
  onSort: (key: SortKey) => void;
}

type SortKey = 'invited_at' | 'joined_at' | 'name';

const isSortKey = (key: string): key is SortKey => key === 'invited_at' || key === 'joined_at' || key === 'name';

const Filter = ({ filter, items, onSort }: FilterProperties) => {
  const currentFilter = items.find((index) => index.key === filter)?.name ?? '';

  return (
    <Dropdown
      menu={{
        items: items.map((menu) => ({ key: menu.key, label: menu.name })),
        onClick({ key }) {
          if (isSortKey(key)) {
            onSort(key);
          }
        },
      }}
      trigger={['click']}
    >
      <Button
        icon={<DownSmallLineIcon color={variables.brandColor.value} size="extra-small" />}
        iconPlacement="end"
        type="link-primary"
      >
        <Flex align="center" gap="xs">
          <Text size="large">Sort by:</Text>
          <Text className="filter__current" size="large" weight="bold">
            {currentFilter}
          </Text>
        </Flex>
      </Button>
    </Dropdown>
  );
};

export default Filter;
